const W = 3150;
const H = 1800;

const loadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("Failed to load: " + src));
    img.src = src;
  });
};

// ─── FRONT SIDE ───
// Template has everything except person's name, title, phone, email
// Overlay areas (based on 3150x1800 template):
//   - Name & title: left side, below states text (~y:1100-1350)
//   - Phone: right side (~x:1500, y:1370) — ALREADY has "(804) 722 - 6032"
//   - Email: right side (~x:1500, y:1570) — ALREADY has "cramusement@gmail.com"
// We need to blank out the phone/email areas and re-draw with the card's values

const drawFront = async (ctx, card) => {
  const template = await loadImage("/images/card-front-template.png");
  ctx.drawImage(template, 0, 0, W, H);

  // Cover ONLY the phone/email TEXT area (right of the gold icon boxes)
  // Icon boxes are at ~x:1340, text starts at ~x:1440
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(1440, 1290, W - 1440, 130); // phone text area
  ctx.fillRect(1440, 1430, W - 1440, 20);  // divider area
  ctx.fillRect(1440, 1470, W - 1440, 130); // email text area

  // Draw new phone number
  ctx.fillStyle = BLACK;
  ctx.font = "bold 68px 'Georgia', serif";
  ctx.textAlign = "left";
  ctx.textBaseline = "middle";
  ctx.fillText(card.phone || "(804) 722 - 6032", 1450, 1355);

  // Divider line
  ctx.strokeStyle = "#ccc";
  ctx.lineWidth = 3;
  ctx.beginPath();
  ctx.moveTo(1450, 1430);
  ctx.lineTo(W - 80, 1430);
  ctx.stroke();

  // Draw new email
  ctx.font = "bold 58px 'Georgia', serif";
  ctx.fillText(card.email || "cramusement@gmail.com", 1450, 1535);

  // Draw person name & title on the existing black area (no black rectangle needed)
  // The black diagonal area at y:1200 extends to about x:430, center at ~x:215 from left
  // At y:1400 it extends to about x:400, so center shifts slightly
  const nameCenterX = 480;

  ctx.fillStyle = "#FFB81C";
  ctx.font = "bold 70px sans-serif";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(card.name.toUpperCase(), nameCenterX, 1350);

  if (card.title) {
    ctx.fillStyle = "rgba(255,255,255,0.85)";
    ctx.font = "italic 44px 'Georgia', serif";
    ctx.fillText(card.title, nameCenterX, 1430);
  }
};

const BLACK = "#000000";

// ─── BACK SIDE (static — no personalization needed) ───
const drawBack = async (ctx) => {
  const template = await loadImage("/images/card-back-template.png");
  ctx.drawImage(template, 0, 0, W, H);
};

// ─── Download front PNG ───
export const generateVisitingCard = async (card) => {
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  await drawFront(canvas.getContext("2d"), card);

  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${card.name.replace(/\s+/g, "_")}_card_front.png`;
      a.click();
      URL.revokeObjectURL(url);
      resolve();
    }, "image/png");
  });
};

// ─── Print front & back ───
export const printVisitingCard = async (card) => {
  const frontCanvas = document.createElement("canvas");
  frontCanvas.width = W;
  frontCanvas.height = H;
  await drawFront(frontCanvas.getContext("2d"), card);

  const backCanvas = document.createElement("canvas");
  backCanvas.width = W;
  backCanvas.height = H;
  await drawBack(backCanvas.getContext("2d"));

  const frontDataUrl = frontCanvas.toDataURL("image/png");
  const backDataUrl = backCanvas.toDataURL("image/png");

  const printWindow = window.open("", "_blank");
  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>${card.name} - Visiting Card</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        @page { size: 3.5in 2in; margin: 0; }
        body { background: #f0f0f0; font-family: sans-serif; }
        .card-page {
          width: 3.5in; height: 2in; margin: 20px auto;
          box-shadow: 0 4px 20px rgba(0,0,0,0.2);
          page-break-after: always;
        }
        .card-page img { width: 100%; height: 100%; display: block; object-fit: contain; }
        .label { text-align: center; padding: 8px; color: #666; font-size: 12px; }
        .print-btn {
          display: block; margin: 20px auto; padding: 12px 40px;
          background: #FFB81C; color: #000; font-weight: bold;
          border: none; border-radius: 8px; cursor: pointer; font-size: 16px;
        }
        .print-btn:hover { background: #e6a518; }
        @media print {
          .no-print { display: none !important; }
          body { background: white; }
          .card-page { margin: 0; box-shadow: none; }
          .label { display: none; }
        }
      </style>
    </head>
    <body>
      <div class="no-print" style="text-align:center;padding:16px;">
        <h2 style="color:#333;margin-bottom:4px;">${card.name}</h2>
        <p style="color:#888;margin-bottom:12px;">Print this page for front & back visiting card</p>
        <button class="print-btn" onclick="window.print()">Print Visiting Card</button>
      </div>
      <p class="label no-print">Front</p>
      <div class="card-page"><img src="${frontDataUrl}" alt="Front" /></div>
      <p class="label no-print">Back</p>
      <div class="card-page"><img src="${backDataUrl}" alt="Back" /></div>
    </body>
    </html>
  `);
  printWindow.document.close();
};
